import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecc37476"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "customer-details"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "customer-details__title h4" }
const _hoisted_4 = { class: "customer-details__description" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "customer-details__icon icon icon-arrow-right" }, null, -1))
const _hoisted_6 = { class: "customer-details__description" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "customer-details__title h4" }
const _hoisted_9 = { class: "customer-details__description" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "customer-details__icon icon icon-arrow-right" }, null, -1))
const _hoisted_11 = {
  key: 1,
  class: "customer-details__error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingOverlay = _resolveComponent("LoadingOverlay")!
  const _component_Combobox = _resolveComponent("Combobox")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_DetailsContainer = _resolveComponent("DetailsContainer")!
  const _component_Article = _resolveComponent("Article")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingOverlay, { "is-active": _ctx.loading }, null, 8, ["is-active"]),
    (_ctx.pageContent && _ctx.accountsData.accounts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.accountsData.accounts.length > 1 && !_ctx.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.pageContent.selectAccountTitle), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.pageContent.selectAccountDescription), 1),
                _createVNode(_component_Combobox, {
                  ref: "address-combobox",
                  modelValue: _ctx.addressValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addressValue) = $event)),
                  "input-id": "select-account",
                  options: _ctx.customerAccountsAddress,
                  label: "Select Your Address"
                }, null, 8, ["modelValue", "options"]),
                _createVNode(_component_AppButton, {
                  class: "customer-details__next-button",
                  disabled: !_ctx.addressValue,
                  "full-width": "",
                  onClick: _ctx.submit
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.nextStepButton), 1),
                    _hoisted_5
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createElementVNode("p", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.pageContent.multiAccountDetailsDescription) + " ", 1),
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.manualAddress && _ctx.manualAddress(...args)))
                  }, _toDisplayString(_ctx.pageContent.multiAccountDetailsEnterAddress), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.pageContent.accountDetailsTitle), 1),
                _createElementVNode("p", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.pageContent.accountDetailsDescription) + " ", 1),
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.manualAddress && _ctx.manualAddress(...args)))
                  }, _toDisplayString(_ctx.pageContent.accountDetailsEnterAddress), 1)
                ]),
                _createVNode(_component_DetailsContainer, {
                  ref: "details-container",
                  "customer-data": _ctx.customerData
                }, null, 8, ["customer-data"]),
                _createVNode(_component_AppButton, {
                  class: "customer-details__next-button",
                  "full-width": "",
                  onClick: _ctx.checkPostcode
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.nextStepButton), 1),
                    _hoisted_10
                  ], undefined, true),
                  _: 1
                }, 8, ["onClick"])
              ]))
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_Article, {
              "text-content": _ctx.pageContent.errorMessage
            }, null, 8, ["text-content"])
          ]))
        : _createCommentVNode("", true)
  ], 64))
}